import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-smart-assistant-unactive",
  "use": "app-icon-smart-assistant-unactive-usage",
  "viewBox": "0 0 24 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 30\" id=\"app-icon-smart-assistant-unactive\"><path d=\"M12 30c3.907-3.945 6.505-6.772 7.793-8.482C22.598 17.795 24 14.624 24 12.007 24 5.376 18.627 0 12 0S0 5.376 0 12.007c0 2.612 1.397 5.775 4.19 9.489C5.48 23.21 8.083 26.044 12 30z\" fill=\"gray\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol